import { IResource } from '../common';

export interface ICreativeFile extends IResource {
    filename: string;
    content_type: string;
    size: number;
    url: string;
    base64_data?: string;
}
